<template>
	<div>
	<router-view></router-view>
	</div>
</template>

<script>
export default {
	computed : {
		role : function(){
			return this.$store.getters.getRole;
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/admin/AdminComponent.vue